<template>
    <v-container grid-list-md class="form-user-payment">
        <v-layout row wrap>
            <v-flex md12>
                <div class="card card-default">
                    <div class="card-header">
                        <h3 class="card-title">
                            Báo lỗi nạp tiền chuyển khoản
                        </h3>
                    </div>
                    <div class="card-body">
                        <v-form ref="form_bot_order_process" lazy-validation>
                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Mã giao dịch</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="transactionCode"
                                            placeholder="Nhập mã giao dịch hóa đơn chuyển tiền"
                                            required
                                            :rules="transactionCodeRule"
                                            hide-details="auto"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Đã chuyển tiền tới tài khoản</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-select
                                            solo
                                            :items="bankAccounts"
                                            v-model="accountId"
                                            item-text="label"
                                            item-value="account_id"
                                            required
                                            :rules="accountIdRule"
                                            hide-details="auto"
                                            @change="updateBankAccount"
                                    ></v-select>
                                    <small class="content-note">
                                        <p class="info-account">
                                            Ngân hàng:<span
                                                class="font-weight-bold ml-9">{{ bankAccount.bank_name }}</span><br>
                                            Chủ tài khoản: <span class="font-weight-bold ml-3">{{ bankAccount.account_name }}</span><br>
                                            Số tài khoản: <span class="font-weight-bold ml-5">{{ bankAccount.account_id }}</span><br>
                                            Chi nhánh: <span class="font-weight-bold ml-9">{{ bankAccount.account_branch }}</span>
                                        </p>
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Hình ảnh hoá đơn chuyển tiền</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-file-input
                                            class="col-5 float-right"
                                            counter
                                            small-chips
                                            show-size
                                            truncate-length="10"
                                            v-model="photo"
                                            accept="image/png, image/jpeg, image/bmp"
                                            :rules="photoRule"
                                    ></v-file-input>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Ghi chú thêm</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-textarea
                                            solo
                                            v-model="note"
                                            hide-details="auto"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md12>
                                    <v-btn width="100%" height="50px" style="background-color: #007bff"
                                           class="white--text payment"
                                           @click="sendReport">
                                        <i class="mdi mdi-cart"></i>
                                        Gửi báo cáo
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { AUTH_GET_INFO_RECHARGE } from '~/store/actions.type'
  import { COMMON_SET_LOADING } from '../../store/mutations.type'
  import {
    REPORT_PAYMENT_ERROR
  } from '../../store/actions.type'

  export default {
    name: 'ReportError',
    components: {},
    data () {
      return {
        transactionCode: '',
        note: '',
        photo: {},
        bankAccounts: [],
        accountId: '',
        bankAccount: {
          bank_name: '',
          account_name: '',
          account_id: '',
          account_branch: ''
        },

        transactionCodeRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],

        accountIdRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],

        photoRule: [
          v => !!v || v.size < 2000000 || 'Hình ảnh không quá 2 MB!',
        ]
      }
    },

    created () {

    },

    computed: {},
    mounted () {
      this.getDataFromApi()
    },
    watch: {},
    methods: {
      async getDataFromApi () {
        let data = await this.$store.dispatch(AUTH_GET_INFO_RECHARGE)
        this.bankAccounts = data.bank_accounts.map(account => {
          account.label = `${account.bank_name} (${account.account_id})`;
          return account;
        })
      },

      updateBankAccount () {
        this.bankAccount = this.bankAccounts.filter(account => account.account_id == this.accountId)[0]
      },

      async sendReport () {
        this.$store.commit(COMMON_SET_LOADING, true)
        await this.$store.dispatch(REPORT_PAYMENT_ERROR, this.getParams())
        this.$store.commit(COMMON_SET_LOADING, false)
      },

      getParams () {
        let formData = new FormData()
        formData.append('transaction_code', this.transactionCode)
        formData.append('bank_account', JSON.stringify(this.bankAccount))
        formData.append('note', this.note)
        formData.append('photo', this.photo)
        return formData
      },
    }
  }
</script>

<style lang="scss">
    @import "../../scss/main";

    .form-user-payment {
        background-color: $bgMainColor;
        max-width: 100% !important;

        /*.v-text-field__details{*/
        /*    !*display: none;*!*/
        /*}*/
        .text-color {
            color: $mainColor;
            font-weight: bold;
        }

        .info-account {
            font-size: 16px;
            padding-right: 7px;
            text-align: justify;
            text-justify: inter-word;
        }
    }
</style>
